import React from "react";
import moment from "moment";
import ReactTable from "react-table";
import matchSorter from "match-sorter";
import { BotonExcel } from "../Plantillas/Botones";
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelSheet;

const CierreCentralizadoUI = ({
    state,
    estadisticasGenerales,
    estadisticasCajaSeleccionada,
    resumenPorCaja,
    dataExcel,
    formatAmount,
    onChangeFecha,
    getMinFechaInicio,
    getMaxFechaInicio,
    getMinFechaFin,
    getMaxFechaFin,
    onChangeSucursal,
    setShowHelp,
    verDetallesCaja,
    clearCajaSeleccionada
}) => {
    const { cajas, isLoading, error, fecha, sucursales, idSucursal, cajaSeleccionada, showHelp, fechaInicio, fechaFin } = state;

    return (
        <section className="ventas-fpay-section-vh pt-5">
            <div className="">
                <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2">
                    <span className="align-self-center letra-fecha-fpay">
                        Desde:
                    </span>
                    <input 
                        disabled={isLoading} 
                        type="date" 
                        onChange={onChangeFecha}
                        name="fechaInicio"
                        className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay" 
                        value={fechaInicio}
                        min={getMinFechaInicio()}
                        max={getMaxFechaInicio()}
                    />
                    <span className="align-self-center letra-fecha-fpay">
                        Hasta:
                    </span>
                    <input 
                        disabled={isLoading} 
                        type="date" 
                        onChange={onChangeFecha}
                        name="fechaFin" 
                        className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay"
                        value={fechaFin}
                        min={getMinFechaFin()}
                        max={getMaxFechaFin()}
                    />
                </div>
                
                <div className="pt-3 container">
                    <div className="col-12 no-pad">
                        <div className="caja-fondo-blanco-m-2 p-3">
                            <label className="sucursal-text-color" htmlFor="sucursales">
                                Seleccione una sucursal
                            </label>
                            <select 
                                value={idSucursal} 
                                name="sucursales" 
                                id="sucursales"
                                className="w-100 select-search-box__search"
                                onChange={onChangeSucursal}
                                disabled={isLoading || sucursales.length === 0}
                            >
                                <option value="">-- Seleccione sucursal --</option>
                                {sucursales.map((sucursal, index) => (
                                    <option key={index} value={sucursal.IdSucursal}>
                                        {sucursal.Nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="mb-2 pt-3">
                        <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => setShowHelp(true)}
                            title="Ver guía de uso"
                        >
                            <i className="fas fa-question-circle mr-1"/> HELP
                        </button>
                    </div>
                </div>
                {/* TOTALES POR TIPO DE PAGO (TOTAL GENERAL) */}
                {cajas && cajas.length > 0 && (
                    <div className="container mt-4">
                        <div className="row">
                            <div className="col-12">
                                <div className="card" style={{background: 'rgba(255, 255, 255, 0.22)'}}>
                                    <div className="card-header d-flex justify-content-between text-white align-items-center" style={{background: '#35605a'}}>
                                        <h5 className="mb-0">
                                            <i className="fas fa-chart-bar mr-2"></i>
                                            Totales por Tipo de Pago - Todas las Cajas
                                        </h5>
                                        <span className="">{cajas.length} cajas</span>
                                    </div>
                                    <div className="card-body p-0">
                                        <table className="table table-hover mb-0">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>Tipo de Pago</th>
                                                    <th className="text-center">Sistema</th>
                                                    <th className="text-center">Usuario</th>
                                                    <th className="text-center">Diferencia</th>
                                                    <th className="text-center">Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Efectivo</strong></td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalEfectivoSistema)}</td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalEfectivoUsuario)}</td>
                                                    <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaEfectivo >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {formatAmount(estadisticasGenerales.diferenciaEfectivo)}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${estadisticasGenerales.diferenciaEfectivo === 0 ? 'badge-success' : 
                                                                         estadisticasGenerales.diferenciaEfectivo > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                            {estadisticasGenerales.diferenciaEfectivo === 0 ? 'OK' : 
                                                             estadisticasGenerales.diferenciaEfectivo > 0 ? 'Sobrante' : 'Faltante'}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Yape</strong></td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalYapeSistema)}</td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalYapeUsuario)}</td>
                                                    <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaYape >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {formatAmount(estadisticasGenerales.diferenciaYape)}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${estadisticasGenerales.diferenciaYape === 0 ? 'badge-success' : 
                                                                         estadisticasGenerales.diferenciaYape > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                            {estadisticasGenerales.diferenciaYape === 0 ? 'OK' : 
                                                             estadisticasGenerales.diferenciaYape > 0 ? 'Sobrante' : 'Faltante'}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>POS</strong></td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalPOSSistema)}</td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalPOSUsuario)}</td>
                                                    <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaPOS >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {formatAmount(estadisticasGenerales.diferenciaPOS)}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${estadisticasGenerales.diferenciaPOS === 0 ? 'badge-success' : 
                                                                         estadisticasGenerales.diferenciaPOS > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                            {estadisticasGenerales.diferenciaPOS === 0 ? 'OK' : 
                                                             estadisticasGenerales.diferenciaPOS > 0 ? 'Sobrante' : 'Faltante'}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Plin</strong></td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalPlinSistema)}</td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalPlinUsuario)}</td>
                                                    <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaPlin >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {formatAmount(estadisticasGenerales.diferenciaPlin)}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${estadisticasGenerales.diferenciaPlin === 0 ? 'badge-success' : 
                                                                         estadisticasGenerales.diferenciaPlin > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                            {estadisticasGenerales.diferenciaPlin === 0 ? 'OK' : 
                                                             estadisticasGenerales.diferenciaPlin > 0 ? 'Sobrante' : 'Faltante'}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Otra Tarjeta</strong></td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalOtraTarjetaSistema)}</td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalOtraTarjetaUsuario)}</td>
                                                    <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaOtraTarjeta >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {formatAmount(estadisticasGenerales.diferenciaOtraTarjeta)}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${estadisticasGenerales.diferenciaOtraTarjeta === 0 ? 'badge-success' : 
                                                                         estadisticasGenerales.diferenciaOtraTarjeta > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                            {estadisticasGenerales.diferenciaOtraTarjeta === 0 ? 'OK' : 
                                                             estadisticasGenerales.diferenciaOtraTarjeta > 0 ? 'Sobrante' : 'Faltante'}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Pedidos Ya</strong></td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalPedidosYaSistema)}</td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalPedidosYaUsuario)}</td>
                                                    <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaPedidosYa >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {formatAmount(estadisticasGenerales.diferenciaPedidosYa)}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${estadisticasGenerales.diferenciaPedidosYa === 0 ? 'badge-success' : 
                                                                         estadisticasGenerales.diferenciaPedidosYa > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                            {estadisticasGenerales.diferenciaPedidosYa === 0 ? 'OK' : 
                                                             estadisticasGenerales.diferenciaPedidosYa > 0 ? 'Sobrante' : 'Faltante'}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Cirkula</strong></td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalCirkulaSistema)}</td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalCirkulaUsuario)}</td>
                                                    <td className={`text-center font-weight-bold ${estadisticasGenerales.diferenciaCirkula >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {formatAmount(estadisticasGenerales.diferenciaCirkula)}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${estadisticasGenerales.diferenciaCirkula === 0 ? 'badge-success' : 
                                                                         estadisticasGenerales.diferenciaCirkula > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                            {estadisticasGenerales.diferenciaCirkula === 0 ? 'OK' : 
                                                             estadisticasGenerales.diferenciaCirkula > 0 ? 'Sobrante' : 'Faltante'}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr className="table-primary font-weight-bold">
                                                    <td><strong>TOTAL GENERAL</strong></td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalSistema)}</td>
                                                    <td className="text-center">{formatAmount(estadisticasGenerales.totalUsuario)}</td>
                                                    <td className={`text-center ${estadisticasGenerales.diferenciaTotal >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {formatAmount(estadisticasGenerales.diferenciaTotal)}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${estadisticasGenerales.diferenciaTotal === 0 ? 'badge-success' : 
                                                                         estadisticasGenerales.diferenciaTotal > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                            {estadisticasGenerales.diferenciaTotal === 0 ? 'CUADRADO' : 
                                                             estadisticasGenerales.diferenciaTotal > 0 ? 'SOBRANTE' : 'FALTANTE'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* RESUMEN POR CAJA - VISTA COMPACTA */}
                {cajas && cajas.length > 0 && (
                    <div className="container mt-4">
                        <div className="row">
                            <div className="col-12">
                                <div className="card" style={{background: 'rgba(255, 255, 255, 0.22)'}}>
                                    <div className="card-header text-white d-flex justify-content-between align-items-center" style={{background:'#35605a'}}>
                                        <h5 className="mb-0">
                                            <i className="fas fa-cash-register mr-2"></i>
                                            Resumen por Caja
                                        </h5>
                                        <span className="">{cajas.length} registros</span>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="table-responsive" style={{maxHeight: '400px', overflowY: 'auto'}}>
                                            <table className="table table-hover mb-0">
                                                <thead className="thead-light sticky-top" style={{top: 0}}>
                                                    <tr>
                                                        <th>Caja</th>
                                                        <th>Usuario</th>
                                                        <th>Estado</th>
                                                        <th className="text-right">Efectivo Sis.</th>
                                                        <th className="text-right">Efectivo Usu.</th>
                                                        <th className="text-right">Dif. Efectivo</th>
                                                        <th className="text-right">Total Sis.</th>
                                                        <th className="text-right">Total Usu.</th>
                                                        <th className="text-right">Dif. Total</th>
                                                        <th className="text-center">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {resumenPorCaja.map((caja, index) => (
                                                        <tr key={index} 
                                                            className={cajaSeleccionada && cajaSeleccionada.IdTurnoCaja === caja.id ? 'table-active' : ''}
                                                            style={{cursor: 'pointer'}}
                                                            onClick={() => verDetallesCaja(caja.rawData)}>
                                                            <td>
                                                                <strong>{caja.nombreCaja}</strong>
                                                            </td>
                                                            <td>
                                                                <small>{caja.usuario}</small>
                                                            </td>
                                                            <td>
                                                                <span className={`badge ${caja.estado === 'Cerrada' ? 'badge-success' : 'badge-warning'}`}>
                                                                    {caja.estado}
                                                                </span>
                                                            </td>
                                                            <td className="text-right">
                                                                <small>{formatAmount(caja.efectivoSistema)}</small>
                                                            </td>
                                                            <td className="text-right">
                                                                <small>{formatAmount(caja.efectivoUsuario)}</small>
                                                            </td>
                                                            <td className={`text-right font-weight-bold ${caja.diferenciaEfectivo >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                <small>{formatAmount(caja.diferenciaEfectivo)}</small>
                                                            </td>
                                                            <td className="text-right">
                                                                <strong>{formatAmount(caja.totalSistema)}</strong>
                                                            </td>
                                                            <td className="text-right">
                                                                <strong>{formatAmount(caja.totalUsuario)}</strong>
                                                            </td>
                                                            <td className={`text-right font-weight-bold ${caja.diferenciaTotal >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                <strong>{formatAmount(caja.diferenciaTotal)}</strong>
                                                            </td>
                                                            <td className="text-center">
                                                                <button 
                                                                    className="btn btn-sm btn-outline-info"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        verDetallesCaja(caja.rawData);
                                                                    }}
                                                                    title="Ver detalles"
                                                                >
                                                                    <i className="fas fa-eye"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* DETALLES DE CAJA SELECCIONADA */}
                {estadisticasCajaSeleccionada && (
                    <div className="container mt-4">
                        <div className="row">
                            <div className="col-12">
                                <div className="card shadow-lg ">
                                    <div className="card-header text-white d-flex justify-content-between align-items-center" style={{background: '#35605a'}}>
                                        <h5 className="mb-0">
                                            <i className="fas fa-info-circle mr-2"></i>
                                            Detalles de Caja: {estadisticasCajaSeleccionada.nombreCaja}
                                        </h5>
                                        <button 
                                            className="btn btn-sm btn-light"
                                            onClick={() => clearCajaSeleccionada()}
                                        >
                                            <i className="fas fa-times"></i> Cerrar
                                        </button>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            {/* Información Básica */}
                                            <div className="col-md-4 mb-3">
                                                <div className="card h-100">
                                                    <div className="card-header text-white" style={{background:'#01a59c'}}>
                                                        <h6 className="mb-0">Información Básica</h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <p className="mb-2">
                                                            <strong>Sucursal:</strong> {estadisticasCajaSeleccionada.sucursal}
                                                        </p>
                                                        <p className="mb-2">
                                                            <strong>Usuario:</strong> {estadisticasCajaSeleccionada.usuario}
                                                        </p>
                                                        <p className="mb-2">
                                                            <strong>Estado:</strong> 
                                                            <span className={`ml-2 badge ${estadisticasCajaSeleccionada.estado === 'Cerrada' ? 'badge-success' : 'badge-warning'}`}>
                                                                {estadisticasCajaSeleccionada.estado}
                                                            </span>
                                                        </p>
                                                        <p className="mb-0">
                                                            <strong>Fecha Inicio:</strong> {estadisticasCajaSeleccionada.fechaInicio}
                                                        </p>
                                                        <p className="mb-0">
                                                            <strong>Fecha Cierre:</strong> {estadisticasCajaSeleccionada.fechaCierre}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Montos Principales */}
                                            <div className="col-md-4 mb-3">
                                                <div className="card h-100">
                                                    <div className="card-header text-white" style={{background:'#01a59c'}}>
                                                        <h6 className="mb-0">Montos Principales</h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <p className="mb-2">
                                                            <strong>Monto Apertura:</strong> 
                                                            <strong className="float-right">{formatAmount(estadisticasCajaSeleccionada.montoInicial)}</strong>
                                                        </p>
                                                        <p className="mb-2">
                                                            <strong>Total Sistema:</strong> 
                                                            <strong className="float-right">{formatAmount(estadisticasCajaSeleccionada.totalSistema)}</strong>
                                                        </p>
                                                        <p className="mb-2">
                                                            <strong>Total Usuario:</strong> 
                                                            <strong className="float-right">{formatAmount(estadisticasCajaSeleccionada.totalUsuario)}</strong>
                                                        </p>
                                                        <p className="mb-0">
                                                            <strong>Diferencia Total:</strong> 
                                                            <strong className={`float-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaTotal >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                {formatAmount(estadisticasCajaSeleccionada.diferenciaTotal)}
                                                            </strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Estado de Caja */}
                                            <div className="col-md-4 mb-3">
                                                <div className="card h-100">
                                                    <div className="card-header text-white" style={{background:'#01a59c'}}>
                                                        <h6 className="mb-0">Estado de Caja</h6>
                                                    </div>
                                                    <div className="card-body text-center">
                                                        <div className={`display-4 ${estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'text-success' : 
                                                                                  estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'text-warning' : 'text-danger'}`}>
                                                            {formatAmount(estadisticasCajaSeleccionada.diferenciaTotal)}
                                                        </div>
                                                        <p className="mb-0">
                                                            <span className={`badge ${estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'badge-success' : 
                                                                             estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                {estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'CAJA CUADRADA' : 
                                                                 estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'SOBRANTE' : 'FALTANTE'}
                                                            </span>
                                                        </p>
                                                        <hr />
                                                        <p className="mb-0">
                                                            <small>Efectivo a entregar: {formatAmount(estadisticasCajaSeleccionada.efectivoSistema)}</small>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Detalles por Tipo de Pago */}
                                            <div className="col-12">
                                                <div className="card">
                                                    <div className="card-header text-white" style={{background:'#01a59c'}}>
                                                        <h6 className="mb-0">Detalles por Tipo de Pago</h6>
                                                    </div>
                                                    <div className="card-body p-0">
                                                        <div className="table-responsive">
                                                            <table className="table table-sm mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Tipo de Pago</th>
                                                                        <th className="text-right">Sistema</th>
                                                                        <th className="text-right">Usuario</th>
                                                                        <th className="text-right">Diferencia</th>
                                                                        <th className="text-center">Estado</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td><strong>Efectivo</strong></td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.efectivoSistema)}</td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.efectivoUsuario)}</td>
                                                                        <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaEfectivo >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                            {formatAmount(estadisticasCajaSeleccionada.diferenciaEfectivo)}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaEfectivo === 0 ? 'badge-success' : 
                                                                                             estadisticasCajaSeleccionada.diferenciaEfectivo > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                {estadisticasCajaSeleccionada.diferenciaEfectivo === 0 ? 'OK' : 
                                                                                 estadisticasCajaSeleccionada.diferenciaEfectivo > 0 ? 'Sobrante' : 'Faltante'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><strong>Yape</strong></td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.yapeSistema)}</td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.yapeUsuario)}</td>
                                                                        <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaYape >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                            {formatAmount(estadisticasCajaSeleccionada.diferenciaYape)}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaYape === 0 ? 'badge-success' : 
                                                                                             estadisticasCajaSeleccionada.diferenciaYape > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                {estadisticasCajaSeleccionada.diferenciaYape === 0 ? 'OK' : 
                                                                                 estadisticasCajaSeleccionada.diferenciaYape > 0 ? 'Sobrante' : 'Faltante'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><strong>POS</strong></td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.posSistema)}</td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.posUsuario)}</td>
                                                                        <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaPOS >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                            {formatAmount(estadisticasCajaSeleccionada.diferenciaPOS)}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaPOS === 0 ? 'badge-success' : 
                                                                                             estadisticasCajaSeleccionada.diferenciaPOS > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                {estadisticasCajaSeleccionada.diferenciaPOS === 0 ? 'OK' : 
                                                                                 estadisticasCajaSeleccionada.diferenciaPOS > 0 ? 'Sobrante' : 'Faltante'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><strong>Plin</strong></td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.plinSistema)}</td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.plinUsuario)}</td>
                                                                        <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaPlin >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                            {formatAmount(estadisticasCajaSeleccionada.diferenciaPlin)}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaPlin === 0 ? 'badge-success' : 
                                                                                             estadisticasCajaSeleccionada.diferenciaPlin > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                {estadisticasCajaSeleccionada.diferenciaPlin === 0 ? 'OK' : 
                                                                                 estadisticasCajaSeleccionada.diferenciaPlin > 0 ? 'Sobrante' : 'Faltante'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><strong>Otra Tarjeta</strong></td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.otraTarjetaSistema)}</td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.otraTarjetaUsuario)}</td>
                                                                        <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaOtraTarjeta >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                            {formatAmount(estadisticasCajaSeleccionada.diferenciaOtraTarjeta)}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaOtraTarjeta === 0 ? 'badge-success' : 
                                                                                             estadisticasCajaSeleccionada.diferenciaOtraTarjeta > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                {estadisticasCajaSeleccionada.diferenciaOtraTarjeta === 0 ? 'OK' : 
                                                                                 estadisticasCajaSeleccionada.diferenciaOtraTarjeta > 0 ? 'Sobrante' : 'Faltante'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><strong>Pedidos Ya</strong></td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.pedidosYaSistema)}</td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.pedidosYaUsuario)}</td>
                                                                        <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaPedidosYa >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                            {formatAmount(estadisticasCajaSeleccionada.diferenciaPedidosYa)}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaPedidosYa === 0 ? 'badge-success' : 
                                                                                             estadisticasCajaSeleccionada.diferenciaPedidosYa > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                {estadisticasCajaSeleccionada.diferenciaPedidosYa === 0 ? 'OK' : 
                                                                                 estadisticasCajaSeleccionada.diferenciaPedidosYa > 0 ? 'Sobrante' : 'Faltante'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td><strong>Cirkula</strong></td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.cirkulaSistema)}</td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.cirkulaUsuario)}</td>
                                                                        <td className={`text-right font-weight-bold ${estadisticasCajaSeleccionada.diferenciaCirkula >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                            {formatAmount(estadisticasCajaSeleccionada.diferenciaCirkula)}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <span className={`badge badge-sm ${estadisticasCajaSeleccionada.diferenciaCirkula === 0 ? 'badge-success' : 
                                                                                             estadisticasCajaSeleccionada.diferenciaCirkula > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                {estadisticasCajaSeleccionada.diferenciaCirkula === 0 ? 'OK' : 
                                                                                 estadisticasCajaSeleccionada.diferenciaCirkula > 0 ? 'Sobrante' : 'Faltante'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="table-active font-weight-bold">
                                                                        <td><strong>TOTAL</strong></td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.totalSistema)}</td>
                                                                        <td className="text-right">{formatAmount(estadisticasCajaSeleccionada.totalUsuario)}</td>
                                                                        <td className={`text-right ${estadisticasCajaSeleccionada.diferenciaTotal >= 0 ? 'text-success' : 'text-danger'}`}>
                                                                            {formatAmount(estadisticasCajaSeleccionada.diferenciaTotal)}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <span className={`badge ${estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'badge-success' : 
                                                                                             estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'badge-warning' : 'badge-danger'}`}>
                                                                                {estadisticasCajaSeleccionada.diferenciaTotal === 0 ? 'CUADRADA' : 
                                                                                 estadisticasCajaSeleccionada.diferenciaTotal > 0 ? 'SOBRANTE' : 'FALTANTE'}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="container">

                    <div align ="right" className="seccion-btn-verde-mfp pt-3 mb-2">
                        <button style={{border:'none', background:'none'}}>

                            <ExcelFile
                                element={
                                    <BotonExcel
                                        className="mr-2"
                                        type="button"
                                        title="Guardar Excel"
                                        />
                                }
                                filename={`ReporteCierreCentral_${fecha}`}
                            >
                                <ExcelSheet
                                    dataSet={dataExcel}
                                    name="Cajas"
                                />
                            </ExcelFile>
                        </button>
                    </div>

                    {error && (
                        <div className="alert alert-danger">
                            {error}
                        </div>
                    )}

                    {cajas && cajas.length === 0 && !isLoading && (
                        <div className="alert alert-info">
                            No se encontraron registros para los filtros seleccionados.
                        </div>
                    )}

                    <ReactTable
                        id="table-productos-to-xls"
                        data={cajas}
                        pages={-1}
                        loading={isLoading}
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]) === filter.value
                        }
                        manual={true}
                        filterable={true}
                        sortable={true}
                        columns={[
                            {
                                columns: [
                                    {
                                        Header: "Caja",
                                        id: "Caja",
                                        width: 120,
                                        accessor: d => d.NombreCaja,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Caja"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Usuario",
                                        id: "Usuario",
                                        width: 130,
                                        accessor: d => d.NombreUsuario,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Usuario"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Estado",
                                        id: "Estado",
                                        width: 100,
                                        accessor: d => d.FechaFin ? (
                                            <span className="badge badge-success">Cerrado</span>
                                        ) : (
                                            <span className="badge badge-warning">En Curso</span>
                                        ),
                                        filterAll: true
                                    },
                                    {
                                        id: 'FechaInicio',
                                        Header: 'Fecha Inicio',
                                        width: 150,
                                        accessor: d => moment(d.FechaInicio).format('DD/MM/YYYY HH:mm')
                                    },
                                    {
                                        id: 'FechaCierre',
                                        Header: 'Fecha Cierre',
                                        width: 150,
                                        accessor: d => d.FechaFin ? moment(d.FechaFin).format('DD/MM/YYYY HH:mm') : "En curso"
                                    },
                                    {
                                        id: "MontoInicial",
                                        Header: "Monto Apertura",
                                        width: 120,
                                        accessor: d => formatAmount(d.MontoInicial)
                                    },
                                    {
                                        Header: "Efectivo Sis.",
                                        id: "EfectivoS",
                                        width: 120,
                                        accessor: d => formatAmount(d.MontoFinalEfectivoSistema),
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["EfectivoS"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Efectivo Usuario",
                                        id: "EfectivoU",
                                        width: 120,
                                        accessor: d => formatAmount(d.MontoFinalEfectivoFisico),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Dif. Efectivo",
                                        id: "DifEfectivo",
                                        width: 100,
                                        accessor: d => {
                                            const dif = parseFloat(d.MontoFinalEfectivoFisico || 0) - parseFloat(d.MontoFinalEfectivoSistema || 0);
                                            return (
                                                <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                    {formatAmount(dif)}
                                                </span>
                                            );
                                        },
                                        filterAll: true
                                    },
                                    {
                                        Header: "YAPE Sis.",
                                        id: "YapeS",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalYapeSistema)
                                    },
                                    {
                                        Header: "YAPE Usuario",
                                        id: "YapeU",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalYape)
                                    },
                                    {
                                        Header: "Dif. YAPE",
                                        id: "DifYape",
                                        width: 100,
                                        accessor: d => {
                                            const dif = parseFloat(d.MontoFinalYape || 0) - parseFloat(d.MontoFinalYapeSistema || 0);
                                            return (
                                                <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                    {formatAmount(dif)}
                                                </span>
                                            );
                                        }
                                    },
                                    {
                                        Header: "POS Sis.",
                                        id: "POSS",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalTarjetaVisaSistema)
                                    },
                                    {
                                        Header: "POS Usuario",
                                        id: "POSU",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalTarjetaVisaFisico)
                                    },
                                    {
                                        Header: "Dif. POS",
                                        id: "DifPOS",
                                        width: 100,
                                        accessor: d => {
                                            const dif = parseFloat(d.MontoFinalTarjetaVisaFisico || 0) - parseFloat(d.MontoFinalTarjetaVisaSistema || 0);
                                            return (
                                                <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                    {formatAmount(dif)}
                                                </span>
                                            );
                                        }
                                    },
                                    {
                                        Header: "Plin Sis.",
                                        id: "PlinS",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalPlinSistema)
                                    },
                                    {
                                        Header: "Plin Usuario",
                                        id: "PlinU",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalPlin)
                                    },
                                    {
                                        Header: "Dif. Plin",
                                        id: "DifPlin",
                                        width: 100,
                                        accessor: d => {
                                            const dif = parseFloat(d.MontoFinalPlin || 0) - parseFloat(d.MontoFinalPlinSistema || 0);
                                            return (
                                                <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                    {formatAmount(dif)}
                                                </span>
                                            );
                                        }
                                    },
                                    {
                                        Header: "Pedidos Ya Sis.",
                                        id: "PedidosYaS",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalTarjetaMasterCardSistema)
                                    },
                                    {
                                        Header: "Pedidos Ya Usuario",
                                        id: "PedidosYaU",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalTarjetaMasterCardFisico)
                                    },
                                    {
                                        Header: "Dif. Pedidos Ya",
                                        id: "DifPedidosYa",
                                        width: 100,
                                        accessor: d => {
                                            const dif = parseFloat(d.MontoFinalTarjetaMasterCardFisico || 0) - parseFloat(d.MontoFinalTarjetaMasterCardSistema || 0);
                                            return (
                                                <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                    {formatAmount(dif)}
                                                </span>
                                            );
                                        }
                                    },
                                    {
                                        Header: "Cirkula Sis.",
                                        id: "CirkulaS",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalTarjetaAmericanSistema)
                                    },
                                    {
                                        Header: "Cirkula Usuario",
                                        id: "CirkulaU",
                                        width: 110,
                                        accessor: d => formatAmount(d.MontoFinalTarjetaAmericanFisico)
                                    },
                                    {
                                        Header: "Dif. Cirkula",
                                        id: "DifCirkula",
                                        width: 100,
                                        accessor: d => {
                                            const dif = parseFloat(d.MontoFinalTarjetaAmericanFisico || 0) - parseFloat(d.MontoFinalTarjetaAmericanSistema || 0);
                                            return (
                                                <span className={dif >= 0 ? 'text-success' : 'text-danger'}>
                                                    {formatAmount(dif)}
                                                </span>
                                            );
                                        }
                                    },
                                ]
                            }
                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        previousText="Anterior"
                        nextText="Siguiente"
                        noDataText="No se encontraron registros"
                        loadingText="Cargando..."
                        ofText="de"
                        rowsText="filas"
                        pageText="Página"
                        pageSizeOptions={[10, 20, 25, 50, 100]}
                    />
                </div>
            </div>

            {showHelp && (
                <div
                    className="modal fade show"
                    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ background: '#35605a' }}>
                                <h5 className="modal-title">
                                    <i className="fas fa-book-open mr-2"/>
                                    Guía: Cierre de Caja Centralizado
                                </h5>
                                <button
                                    type="button"
                                    className="close text-white"
                                    onClick={() => setShowHelp(false)}
                                    aria-label="Cerrar"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="alert alert-info">
                                    <i className="fas fa-info-circle mr-2"/>
                                    Esta guía explica el flujo completo del reporte, desde los filtros hasta la exportación.
                                </div>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-calendar-alt mr-2"/>1. Filtros de búsqueda</h6>
                                <p>Al ingresar verás dos campos de fecha <strong>Desde</strong> y <strong>Hasta</strong> con la fecha actual por defecto. Solo puedes consultar hasta <strong>7 días hacia atrás</strong> para optimizar el rendimiento del sistema. Las fechas se validan automáticamente: si ajustas el inicio más allá del fin, la otra fecha se actualiza en consecuencia.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-building mr-2"/>2. Selección de Sucursal</h6>
                                <p>El selector de <strong>Sucursal</strong> se carga automáticamente al abrir la página trayendo todas las sucursales disponibles. La primera sucursal aparece seleccionada por defecto.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-sync-alt mr-2"/>3. Actualización automática</h6>
                                <p>Al cambiar cualquier filtro (fecha o sucursal) el sistema lanza automáticamente una nueva consulta al servidor, <strong>sin necesidad de presionar ningún botón adicional</strong>. Un indicador de carga aparece mientras se procesan los datos.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-table mr-2"/>4. Totales por Tipo de Pago — Vista general</h6>
                                <p>La primera sección muestra un resumen de <strong>todas las cajas consolidadas</strong> por método de pago: Efectivo, Yape, POS, Plin y Otras Tarjetas. Para cada fila verás:</p>
                                <ul>
                                    <li><strong>Sistema:</strong> monto registrado por el sistema.</li>
                                    <li><strong>Usuario:</strong> monto reportado por el cajero.</li>
                                    <li><strong>Diferencia:</strong> en <span className="text-success">verde</span> si es positiva o <span className="text-danger">rojo</span> si es negativa, con etiqueta <em>OK / Sobrante / Faltante</em>.</li>
                                </ul>
                                <p>La última fila <strong>TOTAL GENERAL</strong> indica con una etiqueta si el consolidado de todas las cajas está <em>CUADRADO</em>, con <em>SOBRANTE</em> o con <em>FALTANTE</em>.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-cash-register mr-2"/>5. Resumen por Caja</h6>
                                <p>La segunda sección lista individualmente cada caja con su nombre, usuario, estado (<em>Abierta / Cerrada</em>), efectivo de sistema vs usuario, diferencia de efectivo y totales generales. Haz clic en <strong>cualquier fila</strong> o en el botón <i className="fas fa-eye"/> para seleccionar esa caja y desplegar su detalle completo.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-info-circle mr-2"/>6. Detalle de Caja Seleccionada</h6>
                                <p>Al seleccionar una caja aparece esta sección organizada en <strong>tres tarjetas</strong>:</p>
                                <ul>
                                    <li><strong>Información básica:</strong> sucursal, usuario, estado, fechas de inicio y cierre.</li>
                                    <li><strong>Montos principales:</strong> monto de apertura, total sistema, total usuario y diferencia total con su color de estado.</li>
                                    <li><strong>Estado de caja:</strong> número destacado que indica si está <em>CUADRADA</em>, con <em>SOBRANTE</em> o con <em>FALTANTE</em>.</li>
                                </ul>
                                <p>Debajo de las tarjetas hay una tabla que desglosa <strong>cada tipo de pago</strong> con sistema, usuario, diferencia y estado, permitiéndote identificar exactamente en qué método existe la discrepancia.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-file-excel mr-2"/>7. Exportación a Excel</h6>
                                <p>El botón verde de Excel genera un archivo <em>.xlsx</em> con todos los datos de las cajas. Las columnas incluyen: caja, sucursal, usuario, estado, fechas, monto de apertura, todos los tipos de pago (sistema y usuario), diferencias y totales. Las diferencias aparecen coloreadas en el Excel para facilitar su lectura.</p>

                                <h6 className="font-weight-bold text-success"><i className="fas fa-list mr-2"/>8. Tabla detallada</h6>
                                <p>Al final de la pantalla encontrarás una tabla completa con todos los registros de caja. Permite <strong>filtrar y ordenar</strong> por cualquier columna, ideal para búsquedas específicas o análisis de registros puntuales. La paginación es configurable entre 10, 20, 25, 50 y 100 filas.</p>

                                <div className="alert alert-secondary mb-0">
                                    <i className="fas fa-lightbulb mr-2 text-warning"/>
                                    <strong>Flujo recomendado:</strong> Elige fechas y sucursal → Revisa totales generales → Explora resumen por caja → Selecciona una caja para ver su detalle → Exporta a Excel si es necesario.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowHelp(false)}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default CierreCentralizadoUI;
